<template>
  <div class="comContent">
    <div class="expand-form">
      <div style="width: 100%; display: flex; justify-content: space-between">
        <searchForm
          v-model="searchData"
          @getList="getList(1)"
          :labelList="expanded ? searchLabelList : expandedList"
          :expanded="expanded"
          :isExpanded="isExpanded"
          :searchData="searchData"
          @reset="resetForm"
          :showExport="false"
        >
        </searchForm>
        <div style="margin-top: 15px">
          <el-button
            size="small"
            type="primary"
            @click="handleExport"
            :loading="exportLoading"
            >导出</el-button
          >
        </div>
      </div>
    </div>
    <priceTotalNotice :count="noticeCount" :list="noticeArr"></priceTotalNotice>
    <myTable
      :index="index"
      :selection="false"
      :page="page"
      :showpage="true"
      :operation="false"
      :table-data="tableData"
      :table-option.sync="tableOption"
      @page-change="getList"
      :expand="false"
      :isLoading="loading"
    >
      <template slot="operation" slot-scope="scope">
        <div style="margin: 0 0px">
          <el-link
            type="primary"
            :underline="false"
            @click="checkDetails(scope.row, 1)"
            style="margin-right: 10px"
            >详情</el-link
          >
          <!--  -->
          <el-link
            type="primary"
            :underline="false"
            @click="handleManualCompensation(scope.row, 1)"
            style="margin-right: 10px"
            v-if="scope.row.needFixSettle"
            >手动补偿</el-link
          >
          <el-link
            type="primary"
            :underline="false"
            v-if="scope.row.contractId"
            @click="lookContract(scope.row, 1)"
            style="margin-right: 10px"
            >查看合同</el-link
          >
        </div>
      </template>
      <template slot="orderCode" slot-scope="scope">
        <el-link @click="checkDetails(scope.row, 1)">{{
          scope.row.orderCode
        }}</el-link>
      </template>
      <template slot="yyName" slot-scope="scope">
        <div style="margin: 0 0px">
          <div v-if="scope.row.yyName">{{ scope.row.yyName }}</div>
          <div v-if="scope.row.yyPhone">{{ scope.row.yyPhone }}</div>
        </div>
      </template>
      <template slot="payShopCode" slot-scope="scope">
        <div style="margin: 0 0px">
          <div>{{ scope.row.payShopCode || "" }}</div>
          <div>{{ scope.row.payShopName || "" }}</div>
        </div>
      </template>
      <template slot="payeeShopCode" slot-scope="scope">
        <div style="margin: 0 0px">
          <div>{{ scope.row.payeeShopCode || "" }}</div>
          <div>{{ scope.row.payeeShopName || "" }}</div>
        </div>
      </template>
      <template slot="status" slot-scope="scope">
        <div style="margin: 0 0px">
          <span v-if="scope.row.status == 1">待付款</span>
          <span v-if="scope.row.status == 2">待发货</span>
          <span v-if="scope.row.status == 3">配送中</span>
          <span v-if="scope.row.status == 5">交易取消</span>
          <span v-if="scope.row.status == 6">申请退款</span>
          <span v-if="scope.row.status == 7">已退款</span>
          <span v-if="scope.row.status == 8">签收 </span>
          <span v-if="scope.row.status == 9"> 完成 </span>
          <span v-if="scope.row.status == 10"> 售后 </span>
          <span v-if="scope.row.status == 11">待开户</span>
          <span v-if="scope.row.status == 12">待确款</span>
          <TimeoutTag :order="scope.row" />
        </div>
      </template>

      <template slot="contactsName" slot-scope="scope">
        <div style="margin: 0 0px" v-if="scope.row.contactsName">
          <div>{{ scope.row.contactsName || "" }}</div>
          <div>{{ scope.row.contactsPhone || "" }}</div>
          <div>{{ scope.row.address || "" }}</div>
        </div>
      </template>
    </myTable>
    <ManualCompensationDialog ref="manualCompensationDialogRef" />
  </div>
</template>
<script>
import searchForm from "../component/searchForm.vue";
import myTable from "@/components/myTable";
import {
  getListByType,
  orderSalePage,
  orderSaleCollect,
  getDownloadUrl,
  exportSaleOrder,
} from "@/api/businessManage";
import TimeoutTag from "./components/timeoutTag.vue";
import ManualCompensationDialog from "./components/manualCompensationDialog.vue";
import priceTotalNotice from "@/components/priceTotalNotice";
export default {
  components: {
    searchForm,
    myTable,
    TimeoutTag,
    ManualCompensationDialog,
    priceTotalNotice,
  },
  props: {},
  data() {
    return {
      expanded: false,
      isExpanded: true,
      loading: false,
      operation: false,
      selection: true,
      index: false,
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "订单创建时间", prop: "orderTime", width: 160 },
        { label: "订单编号", prop: "orderCode", width: 180, slot: true },
        { label: "客户ID/名称", prop: "payShopCode", slot: true },
        // { label: "客户名称", prop: "payShopName", width: 200 },
        { label: "订单金额", prop: "amount", width: 100 },
        { label: "订单状态", prop: "status", slot: true },
        { label: "商户ID/名称", prop: "payeeShopCode", slot: true },
        // { label: "商户名称", prop: "payeeShopName", width: 120 },
        {
          label: "运营人员&联系方式",
          prop: "yyName",
          width: 160,
          slot: true,
        },
        { label: "收货信息", prop: "contactsName", width: 120, slot: true },
        { label: "客户类型", prop: "shopType", width: 100 },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 120,
        },
      ],
      searchData: {
        name: "",
        shopType: "",
        payShopName: "",
        keyWords: "",
        goodsName: "",
        approvalNumber: "",
        code: "",
        status: [],
        date: "",
        startOrderTime: "",
        endOrderTime: "",
      },
      expandedList: [
        {
          name: "客户名称/商品名称/批准文号/订单编号/商户名称",
          fieldName: "keyWords",
          type: "input",
          width: "400",
          placeholder: "客户名称/商品名称/批准文号/订单编号/商户名称",
        },
      ],
      searchLabelList: [
        // {
        //   name: "客户类型",
        //   fieldName: "shopType",
        //   width: 150,
        //   type: "select",
        //   disabled: false,
        //   select: [],
        // },
        {
          name: "客户名称",
          fieldName: "payShopName",
          type: "input",
        },
        {
          name: "商品名称",
          fieldName: "goodsName",
          type: "input",
        },
        {
          name: "批准文号",
          fieldName: "approvalNumber",
          type: "input",
        },
        {
          name: "订单状态",
          width: 150,
          fieldName: "status",
          type: "select",
          disabled: false,
          multiple: true,
          select: [
            {
              name: "待发货",
              id: 2,
            },
            {
              name: "配送中",
              id: 3,
            },
            {
              name: "交易取消",
              id: 5,
            },
            {
              name: "签收",
              id: 8,
            },
            {
              name: "完成",
              id: 9,
            },
            {
              name: "待开户",
              id: 11,
            },
            {
              name: "待确款",
              id: 12,
            },
          ],
        },
        {
          name: "订单编号",
          fieldName: "code",
          type: "input",
          disabled: false,
        },
        {
          name: "商户名称",
          fieldName: "payeeShopName",
          type: "input",
        },

        {
          name: "订单创建日期",
          fieldName: "date",
          type: "date",
        },
      ],
      isRecord: false, //离开页面是否记录当前输入框的值
      recoderKey: "businessManage-order-index",
      noticeArr: [],
      noticeCount: 0,
      exportLoading: false,
    };
  },
  filters: {},
  created() {},
  async mounted() {
    await this.getInputRecoderValue();
    if (this.$route.query.status) {
      this.expanded = true;
      this.searchData.status = [Number(this.$route.query.status)];
      // 默认查询今天的日期
      const d = new Date();
      const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      this.searchData.date = [today, today];
    }
    this.getList();
    this.getListByType();
    if (this.$route.query.shopName) {
      this.searchData.payShopName = this.$route.query.shopName;
    }
  },
  beforeDestroy() {
    if (!this.isRecord) {
      this.$store.dispatch("pageRecorder/clearPageRecord");
    }
  },
  methods: {
    handleExport() {
      const params = this.pendParams();
      this.exportLoading = true;
      exportSaleOrder(params)
        .then((res) => {})
        .catch((err) => {})
        .finally(() => {
          this.exportLoading = false;
        });
    },
    // 记录输入框的值
    recordInput() {
      this.isRecord = true;
      this.$store.dispatch("pageRecorder/addPageRecord", {
        name: this.recoderKey,
        value: { ...this.searchData, expanded: this.expanded },
      });
    },
    // 获取页面记录
    getInputRecoderValue() {
      return new Promise((resolve) => {
        this.$store
          .dispatch("pageRecorder/getRecoderByName", this.recoderKey)
          .then((res) => {
            if (res) {
              // 合并而非整体替换，保证 data 中声明的字段（如 date）响应式不丢失
              this.searchData = { ...this.searchData, ...res };
              this.expanded = res.expanded || false;
            }
          })
          .finally(() => {
            resolve();
          });
      });
    },
    lookContract(row) {
      getDownloadUrl({ signTaskId: row.contractId }).then((res) => {
        if (res) {
          window.open(res.downloadUrl, "_blank");
        }
      });
    },
    // 获取客户类型列表
    getListByType() {
      getListByType({
        type: 1, //商户类型
      }).then((res) => {
        let selectList = [];
        for (let i = 0; i < res.data.length; i++) {
          selectList.push({
            id: res.data[i].typeCode,
            name: res.data[i].typeName,
          });
        }
        for (let i = 0; i < this.searchLabelList.length; i++) {
          if (this.searchLabelList[i].fieldName == "shopTypeId") {
            this.searchLabelList[i].select = selectList;
          }
        }
      });
    },
    pendParams(current) {
      this.searchData.startOrderTime = this.searchData.date
        ? this.searchData.date[0]
        : "";
      this.searchData.endOrderTime = this.searchData.date
        ? this.searchData.date[1]
        : "";
      const params = Object.assign({}, this.searchData);
      params.size = this.page.size;
      delete params.date;
      if (current) {
        params.current = 1;
      } else {
        params.current = this.page.current;
      }
      return params;
    },
    getList(current) {
      this.loading = true;
      const params = this.pendParams(current);
      orderSalePage(params)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.records;
            this.page.total = res.data.total;
          } else {
            this.tableData = [];
            this.page.total = 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
      orderSaleCollect(params)
        .then((res) => {
          if (res) {
            this.countNotices(res);
          }
        })
        .catch(() => {});
    },
    countNotices(item) {
      const { afterSaleAllAmount = 0, orderAllAmount = 0, total = 0 } = item;
      // 计算订单总金额 售后总金额
      const sums = {
        totalAmount: 0,
        afterSaleAmount: 0,
      };
      sums.totalAmount = orderAllAmount;
      sums.afterSaleAmount = afterSaleAllAmount;
      this.noticeCount = total;
      this.noticeArr = Object.entries(sums).map(([key, value]) => {
        const titles = {
          totalAmount: "订单总金额",
          afterSaleAmount: "售后总金额",
        };
        return {
          title: titles[key],
          price: Number(value).toFixed(2),
        };
      });
    },
    resetForm() {
      this.page.current = 1;
      for (const key in this.searchData) {
        if (key == "status") {
          this.searchData[key] = [];
        } else {
          this.searchData[key] = "";
        }
      }
      this.getList();
    },
    // 查看详情
    checkDetails(row) {
      this.recordInput();
      this.$router.push({
        path: "./businessManage-order-detail",
        query: { id: row.id, orderId: row.orderId },
      });
    },
    // 手动补偿
    handleManualCompensation(row) {
      this.$confirm("确认手动补偿？")
        .then(() => {
          this.showPasswordDialog(row);
        })
        .catch(() => {});
    },
    // 密码验证弹窗
    showPasswordDialog(row) {
      this.$prompt("请输入操作密码", "密码校验", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // inputPattern: /^[0-9a-zA-Z]{6}$/,
        // inputErrorMessage: '密码格式错误'
      })
        .then(({ value }) => {
          // cbwx@2025
          if (value == "cbwx@2025") {
            this.handleManualCompensationConfirm(row, value);
          } else {
            this.$message.error("密码错误，请重新输入");
          }
        })
        .catch(() => {});
    },
    // 手动补偿确认
    handleManualCompensationConfirm(row) {
      this.$refs.manualCompensationDialogRef.publicOpen(row);
    },
    handleExpand() {
      this.expanded = !this.expanded;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
  height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}

.expand-form {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>
